export function downloadBlob(content: BlobPart, filename: string, contentType: string): void {
  // Create a blob from the data.
  const blob = new Blob([content], { type: contentType });

  // Create a temporary URL for the blob in browser memory.
  const href = URL.createObjectURL(blob);

  // Create an anchor tag to download the file.
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', filename);
  document.body.appendChild(link);

  // Trigger the download by simulating a click.
  link.click();

  // Clean up the anchor tag and object url.
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}
